import { compactNumber, cx } from "shared/utils";

/**
 * Unread counter pinned to the top-right corner of a chat icon. The parent must
 * be `relative`. Renders nothing at zero.
 */
export const ChatBadge = ({
  count,
  className
}: {
  count: number;
  className?: string;
}) => {
  if (count <= 0) return null;
  return (
    <span
      className={cx(
        "absolute -top-1 -right-1.5 flex h-[17.5px] min-w-[17.5px] items-center justify-center rounded-sm border-[1.5px] border-white bg-primary-500 text-[10px] font-medium leading-4 text-white",
        className
      )}
    >
      {compactNumber(count)}
    </span>
  );
};
